import styled from 'styled-components';
import { UhcMedium } from '@src/apps/styles/common-style';

export const Banner = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  margin: 0 auto;
  background-color: #80dde6;
  color: white;
  height: 40px;
  max-width: 1610px;
  display: flex;
  align-items: center;
  z-index: 1002;
  box-sizing: border-box;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: clamp(24px, 3vw, 50px);
  flex: 0 0 auto;
`;

export const IconButton = styled.div`
  padding-top: 3px;
  color: #2d2d39;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.span`
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #2d2d39;
  user-select: none;

  svg {
    width: 24px;
    height: 24px;
    display: block;
  }
`;

export const ExitLink = styled.span`
  cursor: pointer;
  font-family: ${UhcMedium};
  color: #2d2d39;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;

  &:hover {
    text-decoration: underline;
  }
`;

export const Message = styled.div`
  flex: 1 1 auto;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
  font-family: ${UhcMedium};
  color: #2d2d39;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 24px;
`;

export const ProviderName = styled.span`
  font-weight: bold;
`;